import { secondsToTimeString } from '@/helpers/dateHelper';
import { useCalculateShiftTime } from '@/services/rosters/useCalculateShiftTime';
import { WorkingShift } from '@/types/daily.types';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { InfoCell } from '../../../components/shared/InfoCell';
import { useRosterEmployeeCurrentDaySummary, useRosterEmployeeSummary } from '../providers/WorkingRosterService';

interface AttendanceTotalColumnsProps {
  shift: WorkingShift;
  useShiftTime?: boolean;
}

export const AttendanceTotalColumns: FC<AttendanceTotalColumnsProps> = ({ shift, useShiftTime }) => {
  const employeeSummary = useRosterEmployeeSummary(shift.assignedEmployeeId);
  const daySummary = useRosterEmployeeCurrentDaySummary(shift.assignedEmployeeId);

  const calculateShiftTime = useCalculateShiftTime();

  let rosterTotal = 0;

  if (daySummary && !useShiftTime) {
    rosterTotal = daySummary.basicTime;
  } else {
    // IMPORTANT:
    // 'Why aren't we just displaying the calculated shift times for every row?
    // Why even have the day summary data?'
    //
    // It's because the day summary data allows for split shifts.
    // If I'm working two shifts on a single day, the totals should reflect all the
    // time and breaks across both shifts.

    const { basicTime } = calculateShiftTime(shift);
    rosterTotal = basicTime;
  }

  const baseClass = twMerge('flex-1', employeeSummary?.homeEmployee || useShiftTime ? '' : 'bg-gray-100');

  return (
    <InfoCell className={twMerge(baseClass, 'border-r')}>
      <p>{rosterTotal ? secondsToTimeString(rosterTotal) : '--:--'}</p>
    </InfoCell>
  );
};
